<div
    class="landing-modal"
    [ngClass]="[isVisible ? 'visible' : '', modalInfo ? 'modal-' + modalInfo.mind : '']"
>
    <div class="landing-modal-content">
        <div class="rigth-side">
            <div class="login-modal-container">
                <div class="mind-restricted" *ngIf="!modalInfo?.isMindAllowed">
                    <img src="/assets/icons/warning-icon.svg" alt="" />
                    <div class="mind-restricted__message">
                        <p>
                            <span>Access Restricted: </span> You don’t have permission to access
                            this tool. If you believe you should have access or have a related
                            project for consideration, please reach out to us at
                            <a href="mailto:AILabs@mmc.com">AILabs&#64;mmc.com</a>
                        </p>
                    </div>
                </div>
                <div class="login-modal-container__first-box">
                    <img src="{{ modalInfo?.modal?.iconUrl }}" alt="" />
                    <h1>{{ modalInfo?.name }}</h1>
                    <p class="login-modal-container__second-box__text">
                        {{ modalInfo?.modal?.subtitle }}
                    </p>
                    <button
                        class="login-modal-container__launch"
                        (click)="navigate.emit()"
                        *ngIf="showLaunch && modalInfo?.isMindAllowed"
                    >
                        Launch
                    </button>
                </div>
                <div class="login-modal-container__second-box">
                    <div>
                        <h3>What it is?</h3>
                        <p class="login-modal-container__second-box__text">
                            {{ modalInfo?.modal?.whatItIsText }}
                        </p>
                    </div>
                    <div>
                        <h3>How does it work?</h3>
                        <p class="login-modal-container__second-box__text">
                            {{ modalInfo?.modal?.howDoesItWork }}
                        </p>
                    </div>
                    <div>
                        <h3>Who is it for?</h3>
                        <p class="login-modal-container__second-box__text">
                            {{ modalInfo?.modal?.whoIsItFor }}
                        </p>
                    </div>
                    <div>
                        <h3>Output</h3>
                        <div class="login-modal-container__second-box__output">
                            <img src="{{ modalInfo?.modal?.outputIconUrl }}" alt="" />
                            <p class="login-modal-container__second-box__text">
                                {{ modalInfo?.modal?.output }}
                            </p>
                        </div>
                        <mapp-legal-disclaimer
                            [disclaimerContainerClass]="'login-modal-container__second-box__aclarations'"
                            [imageUrl]="'../../../assets/icons/info-outline.svg'"
                        ></mapp-legal-disclaimer>
                    </div>
                </div>
            </div>
        </div>
        <div class="left-side">
            <div class="close-modal" (click)="closeModal()">
                <span class="close">&times;</span>
            </div>
            <div
                class="big-image"
                [ngStyle]="{
                    'background-image': 'url(' + modalInfo?.modal?.imageUrl + ')',
                }"
            ></div>
        </div>
    </div>
</div>
